import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import {
  Check,
  ArrowRight,
  Anchor,
  Zap,
  Package,
  Upload,
  File,
  Building,
  Users,
  MessageSquare,
  BarChart,
  TrendingUp,
  Clock,
  Info,
  Map,
  Filter,
  Navigation,
  Rocket,
  Shield,
  Eye,
  Globe,
  Server,
  Lock,
  BarChart3,
  Smartphone,
  MessageCircle,
  HelpCircle,
  ChevronDown,
  ChevronUp,
  Search,
} from "lucide-react";

const styles = {
  bg: "#050507",
  cardBg: "rgba(255, 255, 255, 0.05)",
  cardBorder: "rgba(255, 255, 255, 0.1)",
  textPrimary: "#ffffff",
  textSecondary: "rgba(255, 255, 255, 0.7)",
  textMuted: "rgba(255, 255, 255, 0.5)",
  accent: "#22d3ee",
  accentOrange: "#f97316",
  accentGreen: "#34d399",
};

function ScrollToId({ id, children }: { id: string; children: React.ReactNode }) {
  const handleClick = (e: React.MouseEvent) => {
    e.preventDefault();
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: "smooth" });
  };
  return <a href={`#${id}`} onClick={handleClick}>{children}</a>;
}

export default function LandingPageV2() {
  const [openFaq, setOpenFaq] = useState<number | null>(null);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const faqs = [
    {
      q: "Posso disdire quando voglio?",
      a: "Sì, nessun vincolo. Paghi tramite bonifico, nessun addebito automatico sulla carta. Puoi cancellare il tuo account in qualsiasi momento dalle impostazioni.",
    },
    {
      q: "Come pago?",
      a: "Tramite bonifico bancario. Ti inviamo la fattura prima dell'inizio di ogni ciclo di fatturazione. Nessun rinnovo automatico o addebito nascosto.",
    },
    {
      q: "I privati possono vedere gli annunci?",
      a: "Sì, la piattaforma è pubblica per dare più visibilità SEO e geo-localizzazione ai tuoi annunci. I privati possono vedere gli annunci e mettersi in contatto diretto con te, ma le trattative B2B e i prezzi dealer restano riservati agli iscritti.",
    },
    {
      q: "Funziona solo in Italia?",
      a: "Sì, al momento ci concentriamo sul mercato italiano. La piattaforma è progettata per espandersi in futuro.",
    },
    {
      q: "Posso importare dal mio sito web?",
      a: "Sì! La nostra importazione avanzata può estrarre i dati direttamente dalle tue fonti (il tuo sito web, i tuoi annunci sui portali esterni) e sincronizzarli nella piattaforma.",
    },
    {
      q: "Sea Level Intelligence sostituisce il mio perito?",
      a: "Assolutamente no. Sea Level Intelligence monitora i prezzi attuali su internet, ti segnala i falsi annunci e ti mostra la realtà del mercato. È uno strumento intuitivo che amplifica la tua intelligenza e la tua esperienza, non la sostituisce.",
    },
    {
      q: "Come funziona la logistica se trovo una barca lontana?",
      a: "Il nostro network è fatto di professionisti reali. I nostri utenti conoscono i trasportatori, parlano lo stesso slang del settore e si incontrano alle fiere più importanti. Spostare una barca da Nord a Sud per un cliente fidelizzato è parte del lavoro quotidiano.",
    },
    {
      q: "C'è un'app da scaricare?",
      a: "Sea Level Traders è una PWA (Progressive Web App): funziona come un'app su telefono e desktop, anche offline. Non serve scaricarla dagli store: basta visitare sealevel.it dal browser e installarla.",
    },
    {
      q: "Posso usare WhatsApp?",
      a: "Assolutamente sì! Puoi connettere il tuo numero WhatsApp Business alla piattaforma e comunicare con gli altri dealer senza uscire dall'app. Le notifiche arrivano in tempo reale.",
    },
    {
      q: "Quanto costa Sea Level Intelligence?",
      a: "È inclusa in tutti i piani! Mentre altri competitor fanno pagare 30-75€ per ogni quotazione, tu hai valutazioni illimitate incluse nell'abbonamento.",
    },
    {
      q: "Cos'è l'Esclusione Dealer?",
      a: "È una funzione che ti permette di selezionare specifici concessionari e nascondere i tuoi annunci alla loro vista. Utile per gestire relazioni commerciali delicate o sostituire dealer senza conflitti.",
    },
  ];

  const competitors = [
    { name: "Band of Boats", nature: "Mista (Broker+Privati)", price: "80€/mese (25 annunci)", listings: "25-50 (a pagamento)", cats: "Solo barche", intel: "30-75€ a quotazione", import: "Base", double: "Non disponibile", exclusion: "Non disponibile", trade: "Email/Telefono", commission: "Non specificato", lock: "12 mesi" },
    { name: "YachtWorld", nature: "Alto di gamma", price: "Su richiesta", listings: "Limitati", cats: "Solo barche", intel: "Non disponibile", import: "Base", double: "Non disponibile", exclusion: "Non disponibile", trade: "Email/Telefono", commission: "Non specificato", lock: "12 mesi" },
    { name: "iNautia", nature: "Mista", price: "~100€/mese (5 annunci)", listings: "Solo 5", cats: "Solo barche", intel: "Non disponibile", import: "Non disponibile", double: "Non disponibile", exclusion: "Non disponibile", trade: "Email/Telefono", commission: "Non specificato", lock: "12 mesi" },
    { name: "ImpresaPiù / Subito", nature: "Vetrina B2C", price: "Su richiesta", listings: "Variabile", cats: "Solo barche", intel: "Non disponibile", import: "MultiGestionale", double: "Non disponibile", exclusion: "Non disponibile", trade: "Messaggistica base", commission: "Non specificato", lock: "12 mesi" },
  ];

  return (
    <>
      <style>{`
        .landing-v2-bg {
          background: #050507 !important;
          min-height: 100vh;
          color: #fff;
        }
        .landing-v2-container {
          max-width: 900px;
          margin: 0 auto;
          padding: 0 24px;
        }
        .landing-v2-section {
          padding: 80px 24px;
          max-width: 900px;
          margin: 0 auto;
        }
        .landing-v2-section-narrow {
          padding: 80px 24px;
          max-width: 700px;
          margin: 0 auto;
        }
        .landing-v2-section-wide {
          padding: 80px 24px;
          max-width: 1100px;
          margin: 0 auto;
        }
        .landing-v2-glass-card {
          background: rgba(255, 255, 255, 0.05);
          backdrop-filter: blur(16px);
          border: 1px solid rgba(255, 255, 255, 0.1);
          border-radius: 20px;
          padding: 24px;
          transition: all 0.3s ease;
        }
        .landing-v2-glass-card:hover {
          background: rgba(255, 255, 255, 0.08);
          border-color: rgba(34, 211, 238, 0.3);
          transform: translateY(-4px);
        }
        .landing-v2-cta-primary {
          background: linear-gradient(135deg, #f97316, #ea580c) !important;
          color: white !important;
          border: none;
          border-radius: 14px;
          padding: 16px 28px;
          font-weight: 600;
          font-size: 15px;
          display: inline-flex;
          align-items: center;
          gap: 10px;
          box-shadow: 0 4px 20px rgba(249, 115, 22, 0.3);
          transition: all 0.3s ease;
          text-decoration: none;
        }
        .landing-v2-cta-primary:hover {
          transform: translateY(-2px);
          box-shadow: 0 8px 32px rgba(249, 115, 22, 0.4);
        }
        .landing-v2-cta-secondary {
          background: rgba(255, 255, 255, 0.05) !important;
          border: 1px solid rgba(255, 255, 255, 0.1) !important;
          color: white !important;
          border-radius: 14px;
          padding: 16px 28px;
          font-weight: 500;
          font-size: 15px;
          transition: all 0.3s ease;
          text-decoration: none;
          display: inline-flex;
          align-items: center;
          gap: 10px;
        }
        .landing-v2-cta-secondary:hover {
          background: rgba(255, 255, 255, 0.1) !important;
          border-color: rgba(255, 255, 255, 0.2) !important;
        }
        .landing-v2-gradient-text {
          background: linear-gradient(135deg, #22d3ee, #34d399);
          -webkit-background-clip: text;
          -webkit-text-fill-color: transparent;
          background-clip: text;
        }
        .landing-v2-gradient-orange {
          background: linear-gradient(135deg, #f97316, #fbbf24);
          -webkit-background-clip: text;
          -webkit-text-fill-color: transparent;
          background-clip: text;
        }
        .landing-v2-section-title {
          font-size: 2.25rem;
          font-weight: 700;
          color: #fff;
          margin-bottom: 1rem;
          line-height: 1.2;
        }
        .landing-v2-section-subtitle {
          font-size: 1.125rem;
          color: rgba(255, 255, 255, 0.6);
          line-height: 1.6;
        }
        .landing-v2-badge {
          display: inline-flex;
          align-items: center;
          gap: 8px;
          background: rgba(6, 182, 212, 0.15);
          border: 1px solid rgba(6, 182, 212, 0.3);
          color: #22d3ee;
          padding: 8px 16px;
          border-radius: 100px;
          font-size: 13px;
          font-family: 'JetBrains Mono', monospace;
        }
        .landing-v2-badge-dot {
          width: 8px;
          height: 8px;
          border-radius: 50%;
          background: #34d399;
          box-shadow: 0 0 10px #34d399;
        }
        .landing-v2-divider {
          border-top: 1px solid rgba(255, 255, 255, 0.1);
          margin: 80px 0;
        }
        .landing-v2-table {
          width: 100%;
          border-collapse: collapse;
          font-size: 14px;
        }
        .landing-v2-table th {
          background: rgba(6, 182, 212, 0.1);
          padding: 14px 16px;
          text-align: left;
          font-weight: 600;
          color: #fff;
          border-bottom: 1px solid rgba(255, 255, 255, 0.1);
        }
        .landing-v2-table td {
          padding: 14px 16px;
          border-bottom: 1px solid rgba(255, 255, 255, 0.05);
          color: rgba(255, 255, 255, 0.8);
        }
        .landing-v2-table tr:hover td {
          background: rgba(255, 255, 255, 0.03);
        }
        .landing-v2-pricing-card {
          background: rgba(255, 255, 255, 0.05);
          backdrop-filter: blur(16px);
          border: 1px solid rgba(255, 255, 255, 0.1);
          border-radius: 20px;
          padding: 32px;
          transition: all 0.3s ease;
        }
        .landing-v2-pricing-card:hover {
          background: rgba(255, 255, 255, 0.08);
          border-color: rgba(34, 211, 238, 0.3);
          transform: translateY(-4px);
        }
        .landing-v2-pricing-card-featured {
          border-color: rgba(249, 115, 22, 0.4);
          position: relative;
        }
        .landing-v2-faq-item {
          border-bottom: 1px solid rgba(255, 255, 255, 0.05);
        }
        .landing-v2-faq-item:last-child {
          border-bottom: none;
        }
        .landing-v2-faq-question {
          width: 100%;
          text-align: left;
          padding: 20px 0;
          background: none;
          border: none;
          color: #fff;
          font-size: 15px;
          font-weight: 600;
          cursor: pointer;
          display: flex;
          justify-content: space-between;
          align-items: center;
          transition: color 0.2s;
        }
        .landing-v2-faq-question:hover {
          color: #22d3ee;
        }
        .landing-v2-faq-answer {
          padding: 0 0 20px 0;
          color: rgba(255, 255, 255, 0.7);
          font-size: 14px;
          line-height: 1.7;
        }
        .landing-v2-step-card {
          background: rgba(255, 255, 255, 0.05);
          backdrop-filter: blur(16px);
          border: 1px solid rgba(255, 255, 255, 0.1);
          border-radius: 20px;
          padding: 32px;
          text-align: center;
          transition: all 0.3s ease;
        }
        .landing-v2-step-card:hover {
          background: rgba(255, 255, 255, 0.08);
          border-color: rgba(34, 211, 238, 0.3);
          transform: translateY(-4px);
        }
        .landing-v2-step-number {
          width: 48px;
          height: 48px;
          border-radius: 50%;
          display: flex;
          align-items: center;
          justify-content: center;
          font-size: 20px;
          font-weight: 700;
          font-family: 'JetBrains Mono', monospace;
          margin: 0 auto 16px;
          background: rgba(6, 182, 212, 0.2);
          color: #22d3ee;
          border: 1px solid rgba(6, 182, 212, 0.3);
        }
        .landing-v2-problem-card {
          background: rgba(255, 255, 255, 0.03);
          backdrop-filter: blur(16px);
          border: 1px solid rgba(255, 255, 255, 0.08);
          border-radius: 20px;
          padding: 28px;
          text-align: center;
          transition: all 0.3s ease;
        }
        .landing-v2-problem-card:hover {
          background: rgba(255, 255, 255, 0.06);
          border-color: rgba(249, 115, 22, 0.2);
        }
        .landing-v2-pillar-card {
          background: rgba(255, 255, 255, 0.05);
          backdrop-filter: blur(16px);
          border: 1px solid rgba(255, 255, 255, 0.1);
          border-radius: 20px;
          padding: 28px;
          transition: all 0.3s ease;
        }
        .landing-v2-pillar-card:hover {
          background: rgba(255, 255, 255, 0.08);
          border-color: rgba(34, 211, 238, 0.3);
          transform: translateY(-4px);
        }
        .landing-v2-icon-wrapper {
          width: 48px;
          height: 48px;
          border-radius: 14px;
          display: flex;
          align-items: center;
          justify-content: center;
          margin-bottom: 16px;
        }
        .landing-v2-highlight-box {
          background: linear-gradient(180deg, rgba(249, 115, 22, 0.1), transparent);
          border: 1px solid rgba(249, 115, 22, 0.2);
          border-radius: 20px;
          padding: 32px;
        }
        @media (max-width: 768px) {
          .landing-v2-section-title {
            font-size: 1.75rem;
          }
          .landing-v2-section, .landing-v2-section-narrow, .landing-v2-section-wide {
            padding: 60px 16px;
          }
        }
      `}</style>

      <div className="landing-v2-bg">
        {/* ==================== HERO ==================== */}
        <section className="landing-v2-section" style={{ paddingTop: '120px', paddingBottom: '100px' }}>
          <div style={{ textAlign: 'center', maxWidth: '800px', margin: '0 auto' }}>
            <div className="landing-v2-badge" style={{ marginBottom: '32px' }}>
              <span className="landing-v2-badge-dot"></span>
              <span>1 Mese Gratis - Nessun vincolo, disdici quando vuoi</span>
            </div>

            <h1 style={{ fontSize: 'clamp(2.5rem, 6vw, 4rem)', fontWeight: 800, lineHeight: 1.1, marginBottom: '24px', color: '#fff' }}>
              La Prima Piattaforma B2B Che Gestisce Barche, Motori e Accessori.
              <span className="landing-v2-gradient-text" style={{ display: 'block' }}>Con l'Intelligenza dei Dati.</span>
            </h1>

            <p style={{ fontSize: 'clamp(1rem, 2.5vw, 1.25rem)', color: 'rgba(255,255,255,0.7)', maxWidth: '600px', margin: '0 auto 40px', lineHeight: 1.6 }}>
              Sea Level Intelligence monitora i prezzi reali su internet, smaschera i falsi annunci e ti dice chi pubblica cosa e dove. La tua intelligenza amplificata.
            </p>

            <div style={{ display: 'flex', flexWrap: 'wrap', gap: '16px', justifyContent: 'center', marginBottom: '24px' }}>
              <Link to="/register" className="landing-v2-cta-primary">
                Inizia Ora - Registrazione in 2 minuti
                <ArrowRight className="w-5 h-5" />
              </Link>
            </div>

            <p style={{ fontSize: '13px', color: 'rgba(255,255,255,0.5)', display: 'flex', flexWrap: 'wrap', gap: '16px', justifyContent: 'center' }}>
              <span>Pagamento tramite bonifico</span>
              <span>Zero commissioni</span>
              <span>Network esclusivo B2B</span>
            </p>
          </div>
        </section>

        {/* ==================== PROBLEMA ==================== */}
        <section className="landing-v2-section-wide">
          <div style={{ textAlign: 'center', marginBottom: '60px' }}>
            <h2 className="landing-v2-section-title">
              Quante ore perdi ogni settimana a...
            </h2>
          </div>

          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(220px, 1fr))', gap: '20px' }}>
            {[
              { icon: Search, text: "Cercare barche su 5 portali diversi?" },
              { icon: TrendingUp, text: "Valutare permute senza dati reali?" },
              { icon: MessageSquare, text: "Gestire trattative via email infinite?" },
              { icon: Zap, text: "Pagare booster per avere visibilità?" },
            ].map((item, i) => (
              <div key={i} className="landing-v2-problem-card">
                <item.icon className="w-8 h-8" style={{ color: '#f97316', marginBottom: '16px' }} />
                <p style={{ color: 'rgba(255,255,255,0.8)', fontSize: '15px', fontWeight: 500 }}>{item.text}</p>
              </div>
            ))}
          </div>

          <div className="landing-v2-highlight-box" style={{ marginTop: '40px', textAlign: 'center' }}>
            <p style={{ fontSize: '18px', fontWeight: 600, color: '#f97316', margin: 0 }}>
              Noi abbiamo creato la soluzione.
            </p>
          </div>
        </section>

        <div className="landing-v2-divider"></div>

        {/* ==================== 6 PILASTRI ==================== */}
        <section className="landing-v2-section-wide">
          <div style={{ textAlign: 'center', marginBottom: '60px' }}>
            <h2 className="landing-v2-section-title">
              Perché Sea Level Traders è diverso da tutti gli altri
            </h2>
          </div>

          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))', gap: '20px' }}>
            {[
              { icon: Globe, title: "Unico Ecosistema Completo", desc: "Barche, Motori e Accessori in una sola piattaforma. Nessun competitor lo fa.", color: "#22d3ee" },
              { icon: Server, title: "Sea Level Intelligence", desc: "Monitoriamo i prezzi su internet, smascheriamo i falsi, ti diamo i dati giusti. La tua intelligenza amplificata.", color: "#34d399" },
              { icon: Upload, title: "Importazione Avanzata", desc: "Estraiamo dati dal tuo sito web e dai tuoi annunci sui portali. Tu pubblichi una volta, noi sincronizziamo tutto.", color: "#f97316" },
              { icon: Users, title: "Network Collaborativo", desc: "Nessuna guerra di booster. Tutti i dealer hanno le stesse opportunità. Vince la qualità, non il budget.", color: "#22d3ee" },
              { icon: Eye, title: "Controllo Visibilità", desc: "Seleziona quali dealer possono vedere i tuoi annunci. Massima discrezione nelle tue relazioni commerciali.", color: "#34d399" },
              { icon: Lock, title: "Zero Commissioni", desc: "Paghi l'abbonamento, il 100% del margine è tuo. Nessun costo nascosto.", color: "#f97316" },
            ].map((item, i) => (
              <div key={i} className="landing-v2-pillar-card">
                <div className="landing-v2-icon-wrapper" style={{ background: `${item.color}20`, border: `1px solid ${item.color}40` }}>
                  <item.icon className="w-6 h-6" style={{ color: item.color }} />
                </div>
                <h3 style={{ fontSize: '18px', fontWeight: 600, color: '#fff', marginBottom: '8px' }}>{item.title}</h3>
                <p style={{ fontSize: '14px', color: 'rgba(255,255,255,0.6)', lineHeight: 1.6, margin: 0 }}>{item.desc}</p>
              </div>
            ))}
          </div>
        </section>

        <div className="landing-v2-divider"></div>

        {/* ==================== TABELLA COMPARATIVA ==================== */}
        <section className="landing-v2-section-wide">
          <div style={{ textAlign: 'center', marginBottom: '60px' }}>
            <h2 className="landing-v2-section-title">
              Confronta Sea Level Traders con le altre piattaforme
            </h2>
          </div>

          <div style={{ overflowX: 'auto', borderRadius: '20px', border: '1px solid rgba(255,255,255,0.1)', background: 'rgba(255,255,255,0.03)' }}>
            <table className="landing-v2-table">
              <thead>
                <tr>
                  <th>Funzionalità</th>
                  <th style={{ color: '#22d3ee' }}>Sea Level Traders</th>
                  {competitors.map((c, i) => (
                    <th key={i}>{c.name}</th>
                  ))}
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td style={{ fontWeight: 600, color: '#fff' }}>Natura</td>
                  <td style={{ color: '#22d3ee', fontWeight: 600 }}>100% B2B Puro</td>
                  {competitors.map((c, i) => <td key={i}>{c.nature}</td>)}
                </tr>
                <tr>
                  <td style={{ fontWeight: 600, color: '#fff' }}>Prezzo Base</td>
                  <td style={{ color: '#22d3ee', fontWeight: 600 }}>69€/mese</td>
                  {competitors.map((c, i) => <td key={i}>{c.price}</td>)}
                </tr>
                <tr>
                  <td style={{ fontWeight: 600, color: '#fff' }}>Annunci</td>
                  <td style={{ color: '#22d3ee', fontWeight: 600 }}>Illimitati</td>
                  {competitors.map((c, i) => <td key={i}>{c.listings}</td>)}
                </tr>
                <tr>
                  <td style={{ fontWeight: 600, color: '#fff' }}>Categorie</td>
                  <td style={{ color: '#22d3ee', fontWeight: 600 }}>Barche+Motori+Accessori</td>
                  {competitors.map((c, i) => <td key={i}>{c.cats}</td>)}
                </tr>
                <tr>
                  <td style={{ fontWeight: 600, color: '#fff' }}>Intelligence</td>
                  <td style={{ color: '#22d3ee', fontWeight: 600 }}>Illimitata e Inclusa</td>
                  {competitors.map((c, i) => <td key={i}>{c.intel}</td>)}
                </tr>
                <tr>
                  <td style={{ fontWeight: 600, color: '#fff' }}>Import Dati</td>
                  <td style={{ color: '#22d3ee', fontWeight: 600 }}>JSON/CSV+Estrazione fonti</td>
                  {competitors.map((c, i) => <td key={i}>{c.import}</td>)}
                </tr>
                <tr>
                  <td style={{ fontWeight: 600, color: '#fff' }}>Doppio Prezzo</td>
                  <td style={{ color: '#22d3ee', fontWeight: 600 }}>Incluso (B2C/B2B)</td>
                  {competitors.map((c, i) => <td key={i}>{c.double}</td>)}
                </tr>
                <tr>
                  <td style={{ fontWeight: 600, color: '#fff' }}>Esclusione Dealer</td>
                  <td style={{ color: '#22d3ee', fontWeight: 600 }}>Incluso</td>
                  {competitors.map((c, i) => <td key={i}>{c.exclusion}</td>)}
                </tr>
                <tr>
                  <td style={{ fontWeight: 600, color: '#fff' }}>Trattative</td>
                  <td style={{ color: '#22d3ee', fontWeight: 600 }}>Chat+Proposte+Prenotazioni</td>
                  {competitors.map((c, i) => <td key={i}>{c.trade}</td>)}
                </tr>
                <tr>
                  <td style={{ fontWeight: 600, color: '#fff' }}>Commissioni</td>
                  <td style={{ color: '#22d3ee', fontWeight: 600 }}>0%</td>
                  {competitors.map((c, i) => <td key={i}>{c.commission}</td>)}
                </tr>
                <tr>
                  <td style={{ fontWeight: 600, color: '#fff' }}>Vincolo</td>
                  <td style={{ color: '#22d3ee', fontWeight: 600 }}>Nessuno (Bonifico)</td>
                  {competitors.map((c, i) => <td key={i}>{c.lock}</td>)}
                </tr>
              </tbody>
            </table>
          </div>

          <div className="landing-v2-highlight-box" style={{ marginTop: '32px', textAlign: 'center' }}>
            <p style={{ fontSize: '16px', fontWeight: 600, color: '#f97316', margin: 0 }}>
              Mentre gli altri ti fanno pagare per ogni quotazione (30-75€) e booster (16-41€), noi includiamo tutto nell'abbonamento.
            </p>
          </div>
        </section>

        <div className="landing-v2-divider"></div>

        {/* ==================== DUE PIANI ==================== */}
        <section className="landing-v2-section-wide">
          <div style={{ textAlign: 'center', marginBottom: '60px' }}>
            <h2 className="landing-v2-section-title">
              Scegli il piano adatto al tuo business
            </h2>
            <p className="landing-v2-section-subtitle" style={{ maxWidth: '500px', margin: '0 auto' }}>
              Nessun rinnovo automatico. Paghi tramite bonifico. Disdici quando vuoi. Massima fiducia, zero trappole.
            </p>
          </div>

          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))', gap: '24px', maxWidth: '800px', margin: '0 auto' }}>
            {/* Piano Partner */}
            <div className="landing-v2-pricing-card">
              <div style={{ fontSize: '14px', textTransform: 'uppercase', letterSpacing: '0.1em', color: 'rgba(255,255,255,0.5)', marginBottom: '8px', fontWeight: 500 }}>
                Piano Partner
              </div>
              <div style={{ fontSize: '3rem', fontWeight: 800, color: '#fff', marginBottom: '4px', lineHeight: 1 }}>
                €69
              </div>
              <div style={{ fontSize: '14px', color: 'rgba(255,255,255,0.5)', marginBottom: '24px' }}>/mese</div>
              <div style={{ fontSize: '13px', color: 'rgba(255,255,255,0.6)', marginBottom: '24px', padding: '12px', background: 'rgba(255,255,255,0.05)', borderRadius: '12px' }}>
                oppure <strong style={{ color: '#fff' }}>690€/anno</strong> <span style={{ color: '#34d399' }}>(2 mesi gratis)</span>
              </div>
              <p style={{ fontSize: '14px', color: 'rgba(255,255,255,0.7)', marginBottom: '24px', lineHeight: 1.6 }}>
                Il motore del tuo business nautico. Perfetto per concessionari e cantieri che vogliono vendere e comprare con intelligenza.
              </p>
              <ul style={{ listStyle: 'none', padding: 0, margin: 0, marginBottom: '32px' }}>
                {[
                  "Annunci Illimitati (Barche + Motori + Accessori)",
                  "Sea Level Intelligence Inclusa",
                  "Importazione Avanzata (JSON/CSV)",
                  "Doppio Prezzo (B2C / B2B)",
                  "Network Collaborativo",
                  "Trattative Integrate (Chat, WhatsApp)",
                  "Mappa Interattiva GPS",
                  "Esclusione Dealer",
                  "Statistiche Avanzate",
                  "Zero Commissioni",
                  "Visibilità SEO ai privati",
                ].map((feat, i) => (
                  <li key={i} style={{ display: 'flex', alignItems: 'flex-start', gap: '10px', marginBottom: '12px', fontSize: '14px', color: 'rgba(255,255,255,0.7)' }}>
                    <Check className="w-4 h-4" style={{ color: '#34d399', marginTop: '2px', flexShrink: 0 }} />
                    <span>{feat}</span>
                  </li>
                ))}
              </ul>
              <Link to="/register" className="landing-v2-cta-primary" style={{ width: '100%', justifyContent: 'center' }}>
                Scegli Piano Partner
              </Link>
              <p style={{ textAlign: 'center', marginTop: '16px', fontSize: '13px', color: 'rgba(255,255,255,0.5)' }}>
                1 mese gratis per provare
              </p>
            </div>

            {/* Piano Cantiere */}
            <div className="landing-v2-pricing-card landing-v2-pricing-card-featured">
              <div style={{ position: 'absolute', top: '-12px', left: '50%', transform: 'translateX(-50%)', background: '#f97316', color: '#fff', padding: '4px 16px', borderRadius: '100px', fontSize: '12px', fontWeight: 600 }}>
                PIÙ SCELTO
              </div>
              <div style={{ fontSize: '14px', textTransform: 'uppercase', letterSpacing: '0.1em', color: 'rgba(255,255,255,0.5)', marginBottom: '8px', fontWeight: 500, marginTop: '8px' }}>
                Piano Cantiere / Enterprise
              </div>
              <div style={{ fontSize: '3rem', fontWeight: 800, color: '#fff', marginBottom: '4px', lineHeight: 1 }}>
                €119
              </div>
              <div style={{ fontSize: '14px', color: 'rgba(255,255,255,0.5)', marginBottom: '24px' }}>/mese</div>
              <div style={{ fontSize: '13px', color: 'rgba(255,255,255,0.6)', marginBottom: '24px', padding: '12px', background: 'rgba(255,255,255,0.05)', borderRadius: '12px' }}>
                oppure <strong style={{ color: '#fff' }}>1.190€/anno</strong>
              </div>
              <p style={{ fontSize: '14px', color: 'rgba(255,255,255,0.7)', marginBottom: '24px', lineHeight: 1.6 }}>
                Per chi gestisce volumi e strutture complesse. La soluzione definitiva per cantieri navali e multi-agenzie.
              </p>
              <ul style={{ listStyle: 'none', padding: 0, margin: 0, marginBottom: '32px' }}>
                {[
                  "Tutto del Piano Partner",
                  "Multi-Utenza (fino a 5 account staff)",
                  "API Integration (ERP)",
                  "Reportistica Avanzata di Flotta",
                  "Account Manager Dedicato",
                  "Hot Deal Alert Illimitati",
                ].map((feat, i) => (
                  <li key={i} style={{ display: 'flex', alignItems: 'flex-start', gap: '10px', marginBottom: '12px', fontSize: '14px', color: 'rgba(255,255,255,0.7)' }}>
                    <Check className="w-4 h-4" style={{ color: '#34d399', marginTop: '2px', flexShrink: 0 }} />
                    <span>{feat}</span>
                  </li>
                ))}
              </ul>
              <Link to="/register" className="landing-v2-cta-primary" style={{ width: '100%', justifyContent: 'center' }}>
                Scegli Piano Cantiere
              </Link>
              <p style={{ textAlign: 'center', marginTop: '16px', fontSize: '13px', color: 'rgba(255,255,255,0.5)' }}>
                1 mese gratis per provare
              </p>
            </div>
          </div>

          <div className="landing-v2-highlight-box" style={{ marginTop: '40px', textAlign: 'center', maxWidth: '600px', marginLeft: 'auto', marginRight: 'auto' }}>
            <p style={{ fontSize: '16px', fontWeight: 600, color: '#f97316', marginBottom: '8px' }}>
              Hai già usato il mese gratis?
            </p>
            <p style={{ fontSize: '14px', color: 'rgba(255,255,255,0.7)', marginBottom: '16px' }}>
              Per i primi utenti (Founder): passa al pagamento <strong>annuale</strong> e blocca il prezzo a <strong style={{ color: '#f97316' }}>49€/mese (588€/anno) a vita</strong> invece di 69€.
            </p>
            <Link to="/register" className="landing-v2-cta-secondary" style={{ fontSize: '14px', padding: '12px 24px' }}>
              Scopri di più
            </Link>
          </div>
        </section>

        <div className="landing-v2-divider"></div>

        {/* ==================== PERCHÉ ABBIAMO CAMBIATO ==================== */}
        <section className="landing-v2-section-narrow">
          <div style={{ textAlign: 'center', marginBottom: '40px' }}>
            <h2 className="landing-v2-section-title">La verità sul nostro pricing</h2>
          </div>

          <div className="landing-v2-highlight-box">
            <p style={{ fontSize: '15px', color: 'rgba(255,255,255,0.8)', lineHeight: 1.8, margin: 0 }}>
              Fino ad oggi abbiamo offerto un piano a 20€/mese. Era un biglietto di ingresso per farvi provare la piattaforma.
              <br /><br />
              Ma Sea Level Traders non è più in fase di test. I nostri primi partner sono <strong style={{ color: '#fff' }}>player europei conosciuti</strong> per reputazione e volumi di vendita. Avevano a disposizione <strong style={{ color: '#fff' }}>tutte le alternative</strong> del mercato: Mondial Broker, YachtWorld, Band of Boats, Inavis, TrovoBarche, ImpresaPiù, Subito.it, iNautia... e hanno scelto <strong style={{ color: '#22d3ee' }}>noi</strong>.
              <br /><br />
              Perché? Perché hanno visto che <strong style={{ color: '#fff' }}>non siamo un altro portale di annunci</strong>. Siamo un <strong style={{ color: '#fff' }}>sistema operativo per il vostro business</strong>: unico ecosistema che gestisce barche, motori e accessori, Sea Level Intelligence che monitora i prezzi reali e smaschera i falsi, importazione avanzata, network collaborativo, controllo visibilità e mappa interattiva.
              <br /><br />
              Per questo abbiamo eliminato i 20€ e lanciato due piani che riflettono il <strong style={{ color: '#fff' }}>vero valore della piattaforma</strong>. Manteniamo il <strong style={{ color: '#34d399' }}>primo mese gratis</strong>, perché siamo sicuri che una volta provata la differenza, non tornerete indietro.
            </p>
          </div>
        </section>

        <div className="landing-v2-divider"></div>

        {/* ==================== ESCLUSIONE DEALER ==================== */}
        <section className="landing-v2-section-narrow">
          <div style={{ textAlign: 'center', marginBottom: '40px' }}>
            <h2 className="landing-v2-section-title">
              <Eye className="w-8 h-8" style={{ color: '#22d3ee', marginRight: '12px', verticalAlign: 'middle' }} />
              Il Tuo Network, Le Tue Regole: Controllo Totale della Visibilità
            </h2>
          </div>

          <div className="landing-v2-highlight-box">
            <p style={{ fontSize: '15px', color: 'rgba(255,255,255,0.8)', lineHeight: 1.8, margin: 0 }}>
              Le relazioni commerciali nel settore nautico sono delicate.
              <br /><br />
              Sei un cantiere e hai bisogno di espandere la tua rete di concessionari? Hai interrotto una collaborazione con un dealer e devi valutarne la sostituzione senza creare conflitti? Sei un concessionario e vuoi proporti a nuovi cantieri in modo mirato?
              <br /><br />
              Con Sea Level Traders, la trasparenza è totale e il rispetto per il tuo business è la nostra priorità.
              <br /><br />
              Abbiamo sviluppato la funzione <strong style={{ color: '#22d3ee' }}>Esclusione Dealer</strong>: puoi selezionare specifici concessionari e <strong style={{ color: '#fff' }}>nascondere i tuoi annunci alla loro vista</strong>.
              <br /><br />
              <span style={{ color: '#34d399' }}>✓</span> Nessuna visibilità indesiderata verso concorrenti o ex partner
              <br />
              <span style={{ color: '#34d399' }}>✓</span> Massima discrezione quando testi nuovi mercati o sostituisci un dealer
              <br />
              <span style={{ color: '#34d399' }}>✓</span> Gestione pulita delle tue partnership, senza sovrapposizioni o conflitti
              <br /><br />
              Non siamo solo un marketplace. Siamo uno strumento strategico che ti dà il potere di decidere <strong style={{ color: '#fff' }}>chi</strong> può vedere il tuo stock e <strong style={{ color: '#fff' }}>chi</strong> no. Perché il business B2B si basa sulla fiducia, e la fiducia si protegge.
            </p>
          </div>
        </section>

        <div className="landing-v2-divider"></div>

        {/* ==================== COME FUNZIONA ==================== */}
        <section className="landing-v2-section-wide">
          <div style={{ textAlign: 'center', marginBottom: '60px' }}>
            <h2 className="landing-v2-section-title">Inizia in 3 step</h2>
          </div>

          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(250px, 1fr))', gap: '24px' }}>
            {[
              { num: "01", title: "Registrati", desc: "Scegli se sei cantiere o concessionario, compila i dati della tua attività, verifica l'email.", time: "2 minuti" },
              { num: "02", title: "Esplora", desc: "Vedi tutte le barche disponibili, filtra per zona/prezzo/marca, accedi ai prezzi dealer riservati.", time: "Mappa interattiva" },
              { num: "03", title: "Vendi", desc: "Chat integrata, WhatsApp Business, zero commissioni. Chiudi l'affare più velocemente.", time: "Trattative dirette" },
            ].map((step, i) => (
              <div key={i} className="landing-v2-step-card">
                <div className="landing-v2-step-number">{step.num}</div>
                <h3 style={{ fontSize: '20px', fontWeight: 600, color: '#fff', marginBottom: '8px' }}>{step.title}</h3>
                <p style={{ fontSize: '14px', color: 'rgba(255,255,255,0.6)', lineHeight: 1.6, marginBottom: '12px' }}>{step.desc}</p>
                <span style={{ fontSize: '12px', color: '#22d3ee', fontFamily: 'JetBrains Mono, monospace' }}>{step.time}</span>
              </div>
            ))}
          </div>

          <div style={{ textAlign: 'center', marginTop: '48px' }}>
            <Link to="/register" className="landing-v2-cta-primary">
              Inizia Ora
              <ArrowRight className="w-5 h-5" />
            </Link>
          </div>
        </section>

        <div className="landing-v2-divider"></div>

        {/* ==================== FAQ ==================== */}
        <section className="landing-v2-section-narrow">
          <div style={{ textAlign: 'center', marginBottom: '60px' }}>
            <h2 className="landing-v2-section-title">Domande Frequenti</h2>
          </div>

          <div className="landing-v2-glass-card" style={{ padding: 0, overflow: 'hidden' }}>
            {faqs.map((faq, i) => (
              <div key={i} className="landing-v2-faq-item">
                <button
                  className="landing-v2-faq-question"
                  onClick={() => setOpenFaq(openFaq === i ? null : i)}
                  style={{ padding: '0 24px' }}
                >
                  <span>{faq.q}</span>
                  {openFaq === i ? (
                    <ChevronUp className="w-5 h-5" style={{ color: '#22d3ee', flexShrink: 0 }} />
                  ) : (
                    <ChevronDown className="w-5 h-5" style={{ color: '#22d3ee', flexShrink: 0 }} />
                  )}
                </button>
                {openFaq === i && (
                  <div style={{ padding: '0 24px 20px', color: 'rgba(255,255,255,0.7)', fontSize: '14px', lineHeight: 1.7 }}>
                    {faq.a}
                  </div>
                )}
              </div>
            ))}
          </div>
        </section>

        <div className="landing-v2-divider"></div>

        {/* ==================== CTA FINALE ==================== */}
        <section className="landing-v2-section-narrow">
          <div className="landing-v2-highlight-box" style={{ textAlign: 'center' }}>
            <h2 className="landing-v2-section-title" style={{ marginBottom: '16px' }}>
              Unisciti a una network reale di professionisti
            </h2>
            <p className="landing-v2-section-subtitle" style={{ marginBottom: '32px' }}>
              Mentre gli altri vendono visibilità, noi vendiamo efficienza. Il tuo tempo è prezioso. Inizia a usarlo meglio.
            </p>

            <div style={{ display: 'flex', flexDirection: 'column', gap: '12px', marginBottom: '32px', textAlign: 'left', maxWidth: '400px', margin: '0 auto 32px' }}>
              {[
                "1 mese gratis per provare",
                "Nessun vincolo contrattuale",
                "Disdici quando vuoi",
                "Supporto dedicato via email/WhatsApp",
                "Sea Level Intelligence inclusa",
                "Zero commissioni sulle vendite",
              ].map((item, i) => (
                <div key={i} style={{ display: 'flex', alignItems: 'center', gap: '10px', fontSize: '14px', color: 'rgba(255,255,255,0.8)' }}>
                  <Check className="w-4 h-4" style={{ color: '#34d399', flexShrink: 0 }} />
                  <span>{item}</span>
                </div>
              ))}
            </div>

            <Link to="/register" className="landing-v2-cta-primary" style={{ fontSize: '16px', padding: '20px 40px' }}>
              Inizia il tuo mese gratis
              <ArrowRight className="w-5 h-5" />
            </Link>

            <p style={{ fontSize: '13px', color: 'rgba(255,255,255,0.5)', marginTop: '16px' }}>
              Registrazione in 2 minuti • Pagamento tramite bonifico • Fattura elettronica
            </p>
          </div>
        </section>

        {/* ==================== FOOTER ==================== */}
        <footer style={{ borderTop: '1px solid rgba(255,255,255,0.1)', padding: '60px 24px 40px', background: 'rgba(5,5,7,0.85)' }}>
          <div style={{ maxWidth: '900px', margin: '0 auto' }}>
            <div style={{ display: 'flex', flexWrap: 'wrap', gap: '32px', justifyContent: 'space-between', marginBottom: '40px' }}>
              <div>
                <h3 style={{ fontSize: '18px', fontWeight: 700, color: '#fff', marginBottom: '16px' }}>Sea Level Traders</h3>
                <p style={{ fontSize: '14px', color: 'rgba(255,255,255,0.6)', lineHeight: 1.6, maxWidth: '300px' }}>
                  La prima piattaforma B2B che gestisce barche, motori e accessori con Sea Level Intelligence.
                </p>
              </div>
              <div>
                <h4 style={{ fontSize: '14px', fontWeight: 600, color: '#fff', marginBottom: '16px', textTransform: 'uppercase', letterSpacing: '0.05em' }}>Link Utili</h4>
                <div style={{ display: 'flex', flexDirection: 'column', gap: '10px' }}>
                  <Link to="/chi-siamo" style={{ fontSize: '14px', color: 'rgba(255,255,255,0.6)', textDecoration: 'none' }}>Chi Siamo</Link>
                  <Link to="/contatti" style={{ fontSize: '14px', color: 'rgba(255,255,255,0.6)', textDecoration: 'none' }}>Contatti</Link>
                  <Link to="/manuale" style={{ fontSize: '14px', color: 'rgba(255,255,255,0.6)', textDecoration: 'none' }}>Manuale</Link>
                  <Link to="/blog" style={{ fontSize: '14px', color: 'rgba(255,255,255,0.6)', textDecoration: 'none' }}>Blog</Link>
                </div>
              </div>
              <div>
                <h4 style={{ fontSize: '14px', fontWeight: 600, color: '#fff', marginBottom: '16px', textTransform: 'uppercase', letterSpacing: '0.05em' }}>Contatti</h4>
                <div style={{ display: 'flex', flexDirection: 'column', gap: '10px' }}>
                  <a href="mailto:info@sealevel.it" style={{ fontSize: '14px', color: '#22d3ee', textDecoration: 'none' }}>info@sealevel.it</a>
                  <a href="mailto:dealers@sealevel.it" style={{ fontSize: '14px', color: '#22d3ee', textDecoration: 'none' }}>dealers@sealevel.it</a>
                  <span style={{ fontSize: '14px', color: 'rgba(255,255,255,0.5)' }}>www.sealevel.it</span>
                </div>
              </div>
            </div>
            <div style={{ borderTop: '1px solid rgba(255,255,255,0.05)', paddingTop: '24px', display: 'flex', flexWrap: 'wrap', gap: '24px', justifyContent: 'space-between', alignItems: 'center' }}>
              <p style={{ fontSize: '13px', color: 'rgba(255,255,255,0.4)', margin: 0 }}>
                © 2026 Sea Level B2B - Boat Trader. Tutti i diritti riservati.
              </p>
              <div style={{ display: 'flex', gap: '20px' }}>
                <Link to="/privacy" style={{ fontSize: '13px', color: 'rgba(255,255,255,0.4)', textDecoration: 'none' }}>Privacy Policy</Link>
                <Link to="/terms" style={{ fontSize: '13px', color: 'rgba(255,255,255,0.4)', textDecoration: 'none' }}>Termini e Condizioni</Link>
              </div>
            </div>
          </div>
        </footer>
      </div>
    </>
  );
}
